import { useEffect, useState } from 'react'
import { getMapBundleSession, resolveMapAsset } from './defaultMapBundleSession'

/**
 * The URL of a map file in the bundle this page uses, or `null` until it is
 * resolved — a consumer renders nothing rather than a file of another bundle.
 */
export function useMapAssetUrl(name: string): string | null {
  const [resolved, setResolved] = useState<{ name: string; url: string } | null>(null)
  const known = getMapBundleSession().assetUrlIfKnown(name)
  useEffect(() => {
    if (known !== null) return
    let cancelled = false
    void resolveMapAsset(name).then((url) => {
      if (!cancelled) setResolved({ name, url })
    })
    return () => {
      cancelled = true
    }
  }, [name, known])
  if (known !== null) return known
  return resolved !== null && resolved.name === name ? resolved.url : null
}
